export function sliceRoute(url: string): string {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;

    if (pathname === '/shop' || pathname.startsWith('/shop/')) {
      return pathname + parsedUrl.search; // "/shop?..."
    }

    return pathname || '/'; // just "/beauty-tips"
  } catch (e) {
    // Fallback for relative URLs like "/shop?type=new"
    const queryIndex = url.indexOf('?');
    const pathOnly = queryIndex !== -1 ? url.slice(0, queryIndex) : url;
    const queryOnly = queryIndex !== -1 ? url.slice(queryIndex) : '';

    if (pathOnly === '/shop' || pathOnly.startsWith('/shop/')) {
      return pathOnly + queryOnly;
    }

    return pathOnly || '/';
  }
}

export function getQueryParams(
  url: string | Record<string, any>
): Record<string, string> {
  if (typeof url !== 'string') return {};

  try {
    const parsedUrl = new URL(url, 'https://dummy.com'); // Base is needed if it's just a query string
    return Object.fromEntries(parsedUrl.searchParams.entries());
  } catch (e) {
    return {};
  }
}
